export default [
  { to: 'allmant', title: 'Allmänt' },
  { to: 'behandlingsriktlinjer', title: 'Behandlingsriktlinjer' },
  { to: 'information', title: 'Information' },
  { to: 'dosberakning_barn', title: 'Dosberäkning Barn', lockExternal: true },
  { to: 'dosberakning_vuxen', title: 'Dosberäkning Vuxen', lockExternal: true },
  { to: 'fps', title: 'FPS' },
];
